import { Fragment } from 'react';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { Schema } from '../queries';
import { SchemaForm } from './schema-form';
import { SchemaFormLabel } from './schema-form-label';

interface Props {
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaFormObject({ schema, schemaId, path = '' }: Props) {
  const level = path.split('.').length;

  if (schema.type !== 'object') {
    return null;
  }

  const Wrapper = level > 2 ? Card.InnerContent : Fragment;

  return (
    <ListLayout.Stack>
      <Wrapper>
        <ListLayout.Column>
          {level <= 2 && <Card.Separator />}

          <SchemaFormLabel path={path} schema={schema} level={level} schemaId={schemaId} />

          {Object.entries(schema.properties || {}).map(([key, value]) => (
            <SchemaForm schema={value} schemaId={schemaId} path={`${path ? `${path}.` : ''}${key}`} key={key} />
          ))}
        </ListLayout.Column>
      </Wrapper>
    </ListLayout.Stack>
  );
}
